import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';

import { SimpleDialogComponent, SimpleDialogAction } from './simple-dialog.component';
import { translateCommonErrorStatus, StatusTitle, StatusMessage } from '@core/data';

@Injectable()
export class Dialog {

    constructor(private _mdDialog: MatDialog){}

    confirm(title: string, message: string, confirmLabel = 'Confirm', cancelLabel = 'Cancel', negative = true, theme: string = 'dialog-theme'): MatDialogRef<SimpleDialogComponent>{

        let actions = [
            {
                result: false,
                label: cancelLabel,
            },
            {
                result: true,
                label: confirmLabel,
                color: negative ? 'warn' : 'primary',
                raised: true
            },
        ];

        return this.openSimpleDialog(title, message, actions, theme);
    }

    confirmSave(title: string, message: string, confirmLabel = 'Confirm', cancelLabel = 'Cancel', negative = false, theme: string = 'dialog-theme'): MatDialogRef<SimpleDialogComponent>{

        let actions = [
            {
                result: false,
                label: cancelLabel,
            },
            {
                result: true,
                label: confirmLabel,
                color: negative ? 'warn' : 'primary',
                raised: true
            },
        ];

        return this.openSimpleDialog(title, message, actions, theme);
    }

    alert(title: string, message: string, confirmLabel = 'OK', negative = true, theme: string = 'dialog-theme'){
        let actions = [
            {
                result: true,
                label: confirmLabel,
                color: negative ? 'warn' : 'primary',
                raised: true
            },
        ];
        return this.openSimpleDialog(title, message, actions, theme);
    }

    error(error: any){

        const status = translateCommonErrorStatus(error);
        const title = StatusTitle[status];
        const message = StatusMessage[status];

        console.warn("Dialog: displaying error status=%s", status, error);

        return this.alert(title, message);

    }

    openSimpleDialog(title: string, message: string, actions: SimpleDialogAction[], theme: string = 'dialog-theme'){
        let ref = this.open(SimpleDialogComponent, {
            panelClass: theme
        });

        ref.componentInstance.title = title;
        ref.componentInstance.message = message;
        ref.componentInstance.actions = actions;

        return ref;
    }

    open<T>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig) : MatDialogRef<T>{
        return this._mdDialog.open(componentOrTemplateRef, config);
    }

    openFullscreen<T>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig, padding = true) : MatDialogRef<T>{

        let fullscreenConfig = {
            panelClass: padding ? 'pv-fullscreen-dialog-pane' : 'pv-fullscreen-dialog-pane-no-padding',
            width: '100vw',
            height: '100vh'
        };

        return this._mdDialog.open(componentOrTemplateRef, {...fullscreenConfig, ...config});

    }

}